import { Controller } from 'stimulus';
import * as dom from '@core/core/utils/dom';

export default class extends Controller {
  applyFilters(event) {
    event.target.closest('form').submit();
  }

  clearOneFilter(event) {
    dom.uncheckList(event.target.closest('.accordion-element').querySelectorAll('input[type="checkbox"]'));
  }

  clearFilters(event) {
    dom.uncheckList(event.target.closest('form'));
    this.applyFilters(event);
  }
}
